module.exports = __webpack_public_path__ + "img/home_web_09.87b77e91.png";